// extracted by mini-css-extract-plugin
module.exports = {"fadeElement":"fadeIn-module--fadeElement--1lMQN","visible":"fadeIn-module--visible--36Il5"};